import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const userAPI = {
    create: async (userData) => {
        try {
            const { data } = await api.post('/api/user/create/', userData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create user error:');
        }
    },
    getAll: async () => {
        try {
            const { data } = await api.get('/api/users');
            return data;
        } catch (error) {
            handleApiError(error, 'Get all users error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/users/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get user by id error:');
        }
    },
    update: async (id, userData) => {
        try {
            const { data } = await api.put(`/api/users/update/${id}/`, userData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update user error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/users/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete user error:');
        }
    },
    changePassword: async (id, newPassword) => {
        try {
            const { data } = await api.put(`/api/users/change-password/${id}/`, { new_password: newPassword });
            return data;
        } catch (error) {
            handleApiError(error, 'Change password error:');
        }
    },
    getCurrentUser: async () => {
        try {
            let currentUserId = localStorage.getItem('userId');
            
            // If userId is not in localStorage, try to get it from the users list using username
            if (!currentUserId) {
                const username = localStorage.getItem('username');
                if (!username) {
                    throw new Error('No user information found in localStorage');
                }
                
                // Get all users and find the one with matching username
                const users = await userAPI.getAll();
                const currentUser = users.find(user => user.username === username);
                
                if (!currentUser) {
                    throw new Error('Current user not found');
                }
                
                currentUserId = currentUser.id;
                // Store it for future use
                localStorage.setItem('userId', currentUserId);
            }
            
            const { data } = await api.get(`/api/users/${currentUserId}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get current user error:');
        }
    }
}; 